import * as React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Footer from '../Materials/Footer';
import BurgerBar from '../Materials/BurgerBar';
import { useNavigate } from 'react-router-dom';

export default function EventsPage() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const navigate = useNavigate();

  // Estados eventos
  const [events, setEvents] = React.useState([]);
  const [openEventModal, setOpenEventModal] = React.useState(false);
  const [openAddEventModal, setOpenAddEventModal] = React.useState(false);
  const [name, setName] = React.useState('');
  const [initialDate, setInitialDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [duration, setDuration] = React.useState('');
  const [linkPromotor, setLinkPromotor] = React.useState('');
  const [submissionDate, setSubmissionDate] = React.useState('');
  const [resultsDivulgationDate, setResultsDivulgationDate] = React.useState('');
  const [eventTypeId, setEventTypeId] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [selectedEventIndex, setSelectedEventIndex] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  // Estados para mensagens e confirmação
  const [notification, setNotification] = React.useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [openDeleteConfirm, setOpenDeleteConfirm] = React.useState(false);
  const [eventToDelete, setEventToDelete] = React.useState(null);

  // Estados para carregar tipos de eventos
  const [eventTypes, setEventTypes] = React.useState([]);

  // Estados para paginação
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(8);

  // Carregar eventos e tipos de eventos ao montar o componente
  React.useEffect(() => {
    fetchEvents();
    fetchEventTypes();
  }, []);

  // Função para buscar eventos
  const fetchEvents = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/events');
      const data = await response.json();
      setEvents(data);
    } catch (error) {
      console.error('Erro ao buscar eventos:', error);
    }
  };

  // Função para buscar tipos de eventos
  const fetchEventTypes = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/eventTypes');
      const data = await response.json();
      setEventTypes(data);
    } catch (error) {
      console.error('Erro ao buscar tipos de eventos:', error);
    }
  };

  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };

  const handleOpenDeleteConfirm = (event) => {
    setEventToDelete(event);
    setOpenDeleteConfirm(true);
  };

  const handleCloseDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
    setEventToDelete(null);
  };

  const handleAddEvent = async () => {
    if (!name || !initialDate || !endDate || !duration || !eventTypeId || !location) {
      showNotification(
        'Please fill in all required fields before creating the event.',
        'warning'
      );
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          initial_date: initialDate || null,
          end_date: endDate || null,
          duration,
          link_promotor: linkPromotor || null,
          submission_date: submissionDate || null,
          results_divulgation_date: resultsDivulgationDate || null,
          event_type_id: eventTypeId,
          location,
          description: description || null
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to create event');
      }

      const newEvent = await response.json();
      setEvents([...events, newEvent]);
      setOpenAddEventModal(false);
      resetEventForm();
      showNotification('Event created successfully!', 'success');
    } catch (error) {
      console.error('Erro ao adicionar evento:', error);
      showNotification(
        'Unable to create the event. Please check the information and try again.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditEvent = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/events/${events[selectedEventIndex].id}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name,
            initial_date: initialDate,
            end_date: endDate,
            duration,
            link_promotor: linkPromotor,
            submission_date: submissionDate,
            results_divulgation_date: resultsDivulgationDate,
            event_type_id: eventTypeId,
            location,
            description: description || null
          }),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to update event');
      }

      const updatedEvent = await response.json();
      const updatedEvents = [...events];
      updatedEvents[selectedEventIndex] = updatedEvent;

      setEvents(updatedEvents);
      setOpenEventModal(false);
      resetEventForm();
      showNotification('Event updated successfully!', 'success');
    } catch (error) {
      console.error('Erro ao editar evento:', error);
      showNotification(
        'Unable to update the event. Please check the information and try again.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  // Função para deletar um evento
  const handleDeleteEvent = async () => {
    if (!eventToDelete) return;

    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/events/${eventToDelete.id}`,
        { method: 'DELETE' }
      );

      if (!response.ok) {
        throw new Error('Failed to delete event');
      }

      setEvents(events.filter((event) => event.id !== eventToDelete.id));
      handleCloseDeleteConfirm();
      showNotification('Event deleted successfully!', 'success');
    } catch (error) {
      console.error('Erro ao deletar evento:', error);
      showNotification(
        'Unable to delete the event. Please try again.',
        'error'
      );
    }
  };

  const resetEventForm = () => {
    setName('');
    setInitialDate('');
    setEndDate('');
    setDuration('');
    setLinkPromotor('');
    setSubmissionDate('');
    setResultsDivulgationDate('');
    setEventTypeId('');
    setLocation('');
    setDescription('');
    setSelectedEventIndex(null);
  };

  // Função para abrir o modal de edição
  const handleEditEventClick = (index) => {
    const event = events[index];

    setName(event.name);
    setInitialDate(formatDateForInput(event.initial_date));
    setEndDate(formatDateForInput(event.end_date));
    setDuration(event.duration);
    setLinkPromotor(event.link_promotor);
    setSubmissionDate(formatDateForInput(event.submission_date));
    setResultsDivulgationDate(
      formatDateForInput(event.results_divulgation_date)
    );
    setEventTypeId(event.event_type_id);
    setLocation(event.location);
    setDescription(event.description || '');
    setSelectedEventIndex(index);
    setOpenEventModal(true);
  };

  // Função para formatar a data no formato YYYY-MM-DD
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  // Funções para o Navbar e Drawer
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenDrawer(false);
  };

  const handleExit = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  // Funções para paginação
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Eventos mostrados na página atual
  const displayedEvents = events.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      {/* Navbar */}
      <BurgerBar />

      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, py: 4 }}>
        <Container maxWidth="lg">

          <Card>
            <CardContent>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="h6">
                  Events
                </Typography>

                <IconButton
                  color="primary"
                  onClick={() => setOpenAddEventModal(true)}
                >
                  <AddIcon />
                </IconButton>
              </Box>

              <Box sx={{ mt: 2, overflow: 'hidden' }}>

                <TableContainer
                  component={Paper}
                  sx={{ maxHeight: 440, overflow: 'auto' }}
                >
                  <Table stickyHeader sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">
                          Name
                        </TableCell>

                        <TableCell align="center">
                          Initial Date
                        </TableCell>

                        <TableCell align="center">
                          End Date
                        </TableCell>

                        <TableCell align="center">
                          Duration
                        </TableCell>

                        <TableCell align="center">
                          Event Type
                        </TableCell>

                        <TableCell align="center">
                          Location
                        </TableCell>

                        <TableCell align="center">
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {displayedEvents.map((event, index) => (
                        <TableRow key={event.id} hover>

                          <TableCell align="center">
                            {event.name}
                          </TableCell>

                          <TableCell align="center">
                            {new Date(event.initial_date).toLocaleDateString()}
                          </TableCell>

                          <TableCell align="center">
                            {new Date(event.end_date).toLocaleDateString()}
                          </TableCell>

                          <TableCell align="center">
                            {event.duration}
                          </TableCell>

                          <TableCell align="center">
                            {
                              eventTypes.find(
                                (type) => type.id === event.event_type_id
                              )?.name
                            }
                          </TableCell>

                          <TableCell align="center">
                            {event.location}
                          </TableCell>

                          <TableCell align="center">
                            <IconButton
                              color="primary"
                              onClick={() =>
                                handleEditEventClick(
                                  page * rowsPerPage + index
                                )
                              }
                            >
                              <EditIcon />
                            </IconButton>

                            <IconButton
                              color="error"
                              onClick={() =>
                                handleOpenDeleteConfirm(event)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>

                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>

                {/* Paginação */}
                <TablePagination
                  rowsPerPageOptions={[8, 16, 24, 32]}
                  component="div"
                  count={events.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Lines per page:"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${
                      count !== -1 ? count : `mais de ${to}`
                    }`
                  }
                />

              </Box>

            </CardContent>
          </Card>


          {/* Modal de Edição */}
          <Modal
            open={openEventModal}
            onClose={() => setOpenEventModal(false)}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'white',
                padding: 4,
                boxShadow: 24,
                width: '600px',
                maxHeight: '80vh',
                overflow: 'auto',
              }}
            >
              <Typography variant="h6">
                Edit Event
              </Typography>

              <TextField
                fullWidth
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="Initial Date"
                type="date"
                value={initialDate}
                onChange={(e) => setInitialDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                sx={{ mt: 2 }}
                multiline
                rows={4}
              />

              <TextField
                fullWidth
                label="Duration"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="Link Promotor"
                value={linkPromotor}
                onChange={(e) => setLinkPromotor(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="Submission Date"
                type="date"
                value={submissionDate}
                onChange={(e) => setSubmissionDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Results Divulgation Date"
                type="date"
                value={resultsDivulgationDate}
                onChange={(e) =>
                  setResultsDivulgationDate(e.target.value)
                }
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                select
                fullWidth
                label="Event Type"
                value={eventTypeId}
                onChange={(e) => setEventTypeId(e.target.value)}
                sx={{ mt: 2 }}
              >
                {eventTypes.map((type) => (
                  <MenuItem
                    key={type.id}
                    value={type.id}
                  >
                    {type.name}
                  </MenuItem>
                ))}
              </TextField>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditEvent}
                sx={{ mt: 3 }}
              >
                Save Changes
              </Button>

            </Box>
          </Modal>


          {/* Modal de Adição */}
          <Dialog
            open={openAddEventModal}
            onClose={() => setOpenAddEventModal(false)}
          >
            <DialogTitle>
              Create Event
            </DialogTitle>

            <DialogContent>

              <TextField
                fullWidth
                label="Name *"
                value={name}
                onChange={(e) => setName(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="Initial Date *"
                type="date"
                value={initialDate}
                onChange={(e) => setInitialDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="End Date *"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                sx={{ mt: 2 }}
                multiline
                rows={4}
              />

              <TextField
                fullWidth
                label="Duration *"
                type="number"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="Link Promotor"
                value={linkPromotor}
                onChange={(e) => setLinkPromotor(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="Submission Date"
                type="date"
                value={submissionDate}
                onChange={(e) => setSubmissionDate(e.target.value)}
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Results Divulgation Date"
                type="date"
                value={resultsDivulgationDate}
                onChange={(e) =>
                  setResultsDivulgationDate(e.target.value)
                }
                sx={{ mt: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <TextField
                fullWidth
                label="Location *"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                sx={{ mt: 2 }}
              />

              <TextField
                select
                fullWidth
                label="Event Type *"
                value={eventTypeId}
                onChange={(e) => setEventTypeId(e.target.value)}
                sx={{ mt: 2 }}
              >
                {eventTypes.map((type) => (
                  <MenuItem
                    key={type.id}
                    value={type.id}
                  >
                    {type.name}
                  </MenuItem>
                ))}
              </TextField>

            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => setOpenAddEventModal(false)}
                color="error"
              >
                Cancel
              </Button>

              <Button
                onClick={handleAddEvent}
                color="primary"
                disabled={loading}
              >
                {loading ? 'Creating...' : 'Create'}
              </Button>
            </DialogActions>

          </Dialog>


          {/* Confirmação de eliminação */}
          <Dialog
            open={openDeleteConfirm}
            onClose={handleCloseDeleteConfirm}
          >
            <DialogTitle>
              Delete Event
            </DialogTitle>

            <DialogContent>
              <Typography>
                Are you sure you want to delete the event
                <strong> "{eventToDelete?.name}"</strong>?
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1 }}
              >
                This action cannot be undone.
              </Typography>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={handleCloseDeleteConfirm}
                color="inherit"
              >
                Cancel
              </Button>

              <Button
                onClick={handleDeleteEvent}
                color="error"
                variant="contained"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>

        </Container>
      </Box>


      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>


      {/* Footer */}
      <Box>
        <Footer />
      </Box>

    </Box>
  );
}